// Dashboard placeholder — will be populated in Wave 2.

import React from 'react';
import { useStaffMe } from '@/lib/auth';
import { HudReadout, PageHeader, Panel } from '@awakenedlands/ui';

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <Panel>
      <p className="text-sm font-medium text-ink-mid">{label}</p>
      <HudReadout className="mt-1 text-3xl">{value}</HudReadout>
    </Panel>
  );
}

export function DashboardPage() {
  const { data: me } = useStaffMe();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Dashboard"
        description="Awakened Lands staff portal — v1-A"
      />

      {me && (
        <p className="text-sm text-ink-mid">
          Welcome back,{' '}
          <span className="font-medium text-ink-high">{me.username}</span>.
        </p>
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <StatCard label="Open Support Requests" value={0} />
        <StatCard label="Active Locks" value={0} />
        <StatCard label="Active Fedjails" value={0} />
      </div>
    </div>
  );
}
